import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ArrowDownIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6.175 7L10 10.8167L13.825 7L15 8.175L10 13.175L5 8.175L6.175 7Z" />
        </SvgIcon>
    );
};
